// 시세 수집 API
import axiosInstance from './axiosInstance';

// 전체 종목 시세 수집
// save=true: DB 저장 후 결과 반환 (시세수집 버튼)
// save=false: 저장 없이 현재 시세만 반환 (실시간조회 버튼)
// collectStocks: 종목 시세 수집 여부 (default: true)
// collectIndex:  시장지수 수집 여부   (default: true)
// timeout을 120초로 늘림 (종목 수에 따라 수집 시간이 길어질 수 있음)
export const collectPrices = async (save = true, collectStocks = true, collectIndex = true) => {
  const params = `save=${save}&collect_stocks=${collectStocks}&collect_index=${collectIndex}`;
  const res = await axiosInstance.post(`/price/collect?${params}`, null, { timeout: 120000 });
  return res.data;
};

// 전체 종목 최신 시세 목록 조회 (tb_daily_price 기준)
export const fetchLatestPrices = async () => {
  const res = await axiosInstance.get('/price/latest');
  return res.data;
};

// 종목별 실시간 시세 조회 (저장 없음, 실패 시 DB 최신값)
export const fetchRealtimePrice = async (ticker) => {
  const res = await axiosInstance.get(`/price/realtime/${ticker}`);
  return res.data;
};

// 다종목 실시간 시세 일괄 조회 (tickers: 문자열 배열)
// 응답: { success, data: [{ticker, current_price, diff_rate, prev_diff, source}] }
export const fetchRealtimePrices = async (tickers) => {
  const tickerStr = Array.isArray(tickers) ? tickers.join(',') : tickers;
  const res = await axiosInstance.get('/price/realtime', { params: { tickers: tickerStr } });
  return res.data;
};

// 지표종목(is_benchmark=true) 최신 시세 + 환율 조회 (보유/매수 무관, 순수 시세 워치리스트)
export const fetchBenchmarkPrices = async () => {
  const res = await axiosInstance.get('/price/benchmark');
  return res.data;
};

// 종목별 시세 이력 조회
export const fetchPriceHistory = async (ticker, limit = 60) => {
  const res = await axiosInstance.get(`/price/history/${ticker}`, { params: { limit } });
  return res.data;
};

// 다종목 시세 이력 일괄 조회 (종목비교 그래프용, tickers: 배열 또는 콤마 문자열)
// 응답: { success, data: { [ticker]: [{price_date, current_price}] } }
export const fetchMultiPriceHistory = async (tickers, startDate, endDate) => {
  const tickerStr = Array.isArray(tickers) ? tickers.join(',') : tickers;
  const res = await axiosInstance.get('/price/multi-history', {
    params: { tickers: tickerStr, start_date: startDate, end_date: endDate },
  });
  return res.data;
};

// 스케줄 설정 조회
export const fetchScheduleConfig = async () => {
  const res = await axiosInstance.get('/price/schedule');
  return res.data;
};

// 스케줄 설정 저장
export const saveScheduleConfig = async (useSchedule, cronExpr) => {
  const res = await axiosInstance.put('/price/schedule', {
    use_schedule: useSchedule,
    cron_expr:    cronExpr,
  });
  return res.data;
};

// 수동 시세 입력 저장 (price_type='MANUAL' 종목)
export const saveManualPrice = async (ticker, currentPrice) => {
  const res = await axiosInstance.post('/price/manual', {
    ticker,
    current_price: currentPrice,
  });
  return res.data;
};

// AUTO 종목 과거 OHLCV 시세 일괄 수집 (yfinance → tb_daily_price)
export const collectStockHistory = async (startDate, endDate) => {
  const res = await axiosInstance.post('/price/collect-history', {
    start_date: startDate || null,
    end_date:   endDate   || null,
  }, { timeout: 300000 });
  return res.data;
};

// 종목 차트 데이터 조회 (tb_daily_price + 52주 고저가)
// period: '1m' | '3m' | '6m' | '1y' | '3y' | '5y'
export const getChartData = async (ticker, period = '1y') => {
  const res = await axiosInstance.get('/price/chart', { params: { ticker, period } });
  return res.data;
};
